import postAPI from './postAPI.js'

export default async function postCreateTaskInstance(body) {
    const data = await postAPI('admin/taskinstances/create', body);
    return data;
}
